<template>
  <li v-if="index>0"
      class="main-menu__item"
      :class="{'main-menu__item--selected':isSelected}">
    <a v-if="section.subSections.length > 0"
       class="main-menu__item--link"
       @click.prevent="isOpen = !isOpen"
       :class="{'selected-item':isSelected}"
       href="#">
      {{ section.title }}<span v-if="section.subSections.length > 0"
                               class="menu-arrow"
                               :class="{'js-menu-arrow--flip':isOpen}"></span>
    </a>
    <router-link active-class="selected-item"
                 class="main-menu__item--link"
                 :class="{'selected-item':selectedSectionId === section.id}"
                 :to="'/'+section.slug"
                 v-if="section.subSections.length === 0">
      {{ section.title }}<span v-if="section.subSections.length > 0"
                               class="menu-arrow"
                               :class="{'js-menu-arrow--flip':isOpen}"></span>
    </router-link>

    <transition name="accordion">
      <ul v-if="section.subSections.length > 0 && isOpen" class="sub-menu">
        <li v-for="subSection in section.subSections">
          <router-link class="sub-menu__item" :class="{'selected-item':isSelectedCheck(subSection.slug)}"
                       :to="'/'+section.slug+'/'+subSection.slug">
            {{ subSection.title }}
          </router-link>
        </li>
      </ul>
    </transition>
  </li>
</template>
<script>
  export default {
    props: ['section', 'index'],
    data () {
      return {
        isOpen: false
      }
    },
    methods: {
      isSelectedCheck (subSectionId) {
        if (this.$route.name === 'Section' || this.$route.name === 'SubSection') {
          if (typeof subSectionId !== 'undefined') {
            return (this.$route.params.slug2 === subSectionId)
          }
          return (this.$route.params.slug === this.section.slug)
        }
        return false
      }
    },
    created () {
      this.isOpen = this.isSelected
    },
    computed: {
      selectedSectionId () {
        return this.$store.getters.selectedSectionId
      },
      isSelected () {
        if (this.$route.name === 'Section' || this.$route.name === 'SubSection') {
          // if (typeof subSectionId !== 'undefined') {
          //   return (this.$route.params.slug2 === subSectionId)
          // }
          return (this.$route.params.slug === this.section.slug)
        }
        return false
      }
    },
    watch: {
      '$route' (to, from) {
        this.isOpen = this.isSelected
      }
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/MenuSection.vue